import { gql } from '@ts-gql/tag'

export const GetNationalHomepageQuery = gql`
  query NationalHomepage($country: String!) {
    cfNationalHomepageCollection(
      limit: 1
      where: { country_contains_all: [$country] }
    ) {
      items {
        navigationMenu
      }
    }
  }
` as import('../../../../__generated__/ts-gql/NationalHomepage').type
